(function() {
  'use strict';

  window.decorateFormWithModalFields = function(formElem) {
    var $form = $(formElem);
    var $fields = $form.find('[data-modal-field]');

    if ($fields.length > 0) {
      new ModalFieldsController($form, $fields)
    }
  }

  document.addEventListener('turbo:load', errors.tryFn(function() {
    if ($('[data-modal-field]').length === 0) { return }
    $('form').get().forEach(decorateFormWithModalFields);
  }));
})();
